import axios from 'helper/axios-facade';
import appConfig from 'helper/mapBackendConfig';

// TODO: Add types!
export const fetchExercises = () => {
	const requestUrl = `${appConfig.env.urlMagnoliaAPICoach}/exercises/override`;

	return axios.get(requestUrl, {
		withCredentials: false,
	});
};
